/**
 * formatNumber.js
 *
 * @Author: apple
 * @Date: 2017/8/30 19:21
 */

import { isNumber } from './isType';
const round = (value, exp = 0) => {
  const decimal = Math.pow(10, exp);
  value = +value;
  if (isNaN(value)) {
    return NaN;
  }
  return Math.round(value * decimal) / decimal;
};
const floor = (value, exp = 0) => {
  const decimal = Math.pow(10, exp);
  value = +value;
  if (isNaN(value)) {
    return NaN;
  }
  return Math.floor(value * decimal) / decimal;
};

/*
 * formatNumber(99999, 0, 'floor') // ===> '9 万'
 * formatNumber(99999, 0, 'round') // ===> '10 万'
 * */
const formatNumber = (number, exp = 2, ellipsis = 'round') => {
  const method = {
    round: round,
    floor: floor,
  };
  return isNumber(number)
    ? number > -1
      ? (number >= 100000000
          ? method[ellipsis](number / 100000000, exp) + ' 亿'
          : number >= 10000
          ? method[ellipsis](number / 10000, exp) + ' 万'
          : number >= 0
          ? method[ellipsis](number, exp) + ' '
          : number + ' '
        ).replace(/(\d{1,3})(?=(\d{3})+(?:$|\D))/g, '$1, ')
      : '-'
    : number;
};

const formatNumberNew = (number, exp = 2, ellipsis = 'round') => {
  const method = {
    round: round,
    floor: floor,
  };

  if (isNumber(number)) {
    const absNum = Math.abs(number);
    const formatNum = (absNum >= 100000000
      ? method[ellipsis](absNum / 100000000, exp) + ' 亿'
      : absNum >= 10000
      ? method[ellipsis](absNum / 10000, exp) + ' 万'
      : absNum >= 0
      ? method[ellipsis](absNum, exp) + ' '
      : absNum + ' '
    ).replace(/(\d{1,3})(?=(\d{3})+(?:$|\D))/g, '$1, ');
    return number >= 0 ? `${formatNum}` : `-${formatNum}`;
  }
  return number;
};

export { formatNumberNew };

export default formatNumber;
